
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";

export default function ConfirmSection({ workshop }) {
	return (
		<div className="w-full bg-white rounded-[10px] p-[10px]">
			<div className="flex flex-row items-center">
				<div className="text-[#4B5155] font-Vazir-400 text-[14px]">وضعیت:</div>
				<div className="spacer p-[5px]"></div>
				<div className="text-[#4B5155] font-Vazir-400 text-[14px]">{workshop.fa_confirm_state}</div>
			</div>
			{workshop.confirm_state !== "confirmed" && workshop.refuse_message && (
				<>
					<div className="spacer p-[5px]"></div>
					<div className="text-[#4B5155] font-Vazir-400 text-[14px]">توضیح رد:</div>
					<div className="spacer p-[5px]"></div>
					<div className="text-[#4B5155] font-Vazir-400 text-[14px]">{workshop.refuse_message}</div>
				</>
			)}
		</div>
	)
}
